// src/hooks/useBreakpoint.ts

import { useState, useEffect } from 'react';

export function useBreakpoint() {
  // Toujours 0 au premier rendu (serveur ET premier rendu client identiques
  // → pas de mismatch d'hydratation) ; la vraie largeur n'arrive qu'après
  // montage, via l'effet ci-dessous.
  const [w, setW] = useState(0);

  useEffect(() => {
    const handler = () => setW(window.innerWidth);
    handler();
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const isMobile  = w < 640;
  const isTablet  = w >= 640 && w < 1024;
  const isDesktop = w >= 1024;
  const isXl      = w >= 1440;
  const isXxl     = w >= 1920;

  // Résout le nombre de colonnes CSS selon le breakpoint actuel
  // Usage : cols(mobile, tablet, desktop, xl?, xxl?)
  function cols(m: number, t: number, d: number, xl = d, xxl = xl): number {
    if (isXxl)     return xxl;
    if (isXl)      return xl;
    if (isDesktop) return d;
    if (isTablet)  return t;
    return m;
  }

  // Padding latéral de page
  const px = isXxl ? 64 : isXl ? 40 : isDesktop ? 28 : isTablet ? 20 : 16;

  // Max-width du conteneur principal (fluide sur xxl, pas de murs blancs)
  const maxW = isXxl ? '2200px' : isXl ? '1600px' : isDesktop ? '1280px' : '100%';

  return { w, isMobile, isTablet, isDesktop, isXl, isXxl, cols, px, maxW };
}